module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "mchap0",
    attrs: {
      "id": "b1"
    }
  }, [_c('b', [_vm._v("ALSO IN THIS SERIES")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Death Miser")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Redhead")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("First Came a Murder")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Death Round the Corner")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Mark of the Crescent")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Thunder in Europe")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Terror Trap")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Carriers of Death")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Days of Danger")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Death Stands By")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Menace")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Murder Must Wait")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Panic!")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Death by Night")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Island of Peril")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Sabotage")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Go Away Death")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Day of Disaster")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Prepare for Action")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("No Darker Crime")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Dark Peril")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Peril Ahead")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The League of Dark Men")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Department of Death")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Enemy Within")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("Dead or Alive")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("A Kind of Prisoner")]), _vm._v(" "), _c('p', {
    staticClass: "mcenter0"
  }, [_vm._v("The Black Spiders")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a5c6ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/back00x.vue
// module id = 57
// module chunks = 0